import { createContext, useContext } from "react";
import type Feature from "ol/Feature";

interface FeatureContextType {
  selectedFeatures: Feature[];
  setSelectedFeatures: (features: Feature[]) => void;
  addFeature: (feature: Feature) => void;
  removeFeature: (feature: Feature) => void;
  clearFeatures: () => void;
}

export const FeatureContext = createContext<FeatureContextType | undefined>(
  undefined,
);

export const useFeatureContext = (): FeatureContextType => {
  const context = useContext(FeatureContext);
  if (!context) {
    throw new Error("useFeatureContext must be used within a FeatureProvider");
  }
  return context;
};
